import api from '@/api'
import Axios from 'axios'
import router from "@/router"

export default {
  namespaced: true,
  state: {
    token: localStorage.getItem('token') || null,
    account: null,
    show_terms: false,
    sms_token: '',
    continue: '',
    last_saved: null
  },
  getters: {
    isBusiness: function(state) {
      if (state.account) {
        if (state.account.type === 'business') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isAdmin: function(state) {
      if (state.account) {
        if (state.account.type === 'admin') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    },
    isLoggedIn: function(state) {
      return state.token ? true : false
    },
    type: function(state) {
      if (state.account) {
        return state.account.type
      } else {
        return 'visitor'
      }
    }
  },
  mutations: {
    account_updated(state, account) {
      state.last_saved = new Date()
      state.account = account;
      setTimeout(function() {
        state.last_saved = false
      }, 1000)
    },
    set_continue(state, to) {
      state.continue = to
    },
    change_account_type(state, to) {
      state.account.type = to
    },
    account_loaded(state, account) {
      state.account = account
      if (state.account.accepted_terms != 1) {
        state.show_terms = true
      }
    },
    set_token(state, token) {
      state.token = token
      api.defaults.headers.common['Authorization'] = token;
      localStorage.setItem('token', token);
    },
    logout(state) {
      state.token = null;
      state.account = null;
      state.show_terms = false;
      localStorage.removeItem('token')
      delete api.defaults.headers.common['Authorization']
      try {
        console.log("FB logout!")
        window.FB.logout()
      } catch (ex) {
        console.log("Facebook wasnt logged in", ex)
      }
      state.continue = router.currentRoute
      router.push("/")
    },
    validation_success(state, token) {
      state.sms_token = token;
    },
    toggle_bookmark(state, data) {
      if (state.account.contest_bookmarks) {
        if (state.account.contest_bookmarks.includes(data)) {
          state.account.contest_bookmarks.splice(state.account.contest_bookmarks.indexOf(data), 1)
        } else {
          state.account.contest_bookmarks.push(data)
        }
      } else {
        state.account.contest_bookmarks = [];
        state.account.contest_bookmarks.push(data)
      }
    }
  },
  actions: {
    claimEdit: async function(context) {
      await api({
        method: "GET",
        url: `/account/user/claim-edit`
      })
      context.state.account.edit_available = 0;
      context.state.account.edit_claimed = 1;
    },
    async delete(context) {
      await api({
        url: `/account/delete-account`
      })
      context.commit('logout')
    },
    async loadAccount({
      dispatch,
      commit
    }) {
      try {
        let account = await api({
          url: `/account`
        })
        commit('account_loaded', account)
        dispatch('notifications/load', null, {
          root: true
        })
      } catch (ex) {
        commit("logout")
      }
    },
    async init(context) {
      if (context.state.token) {
        api.defaults.headers.common['Authorization'] = context.state.token;
        await context.dispatch('loadAccount')
      }
    },
    async login(context, credentials) {
      let response = await api({
        url: `/login`,
        method: 'POST',
        data: credentials
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/")
      }
    },
    async google_login(context, access_token) {
      let response = await api({
        url: `/google-login`,
        method: 'POST',
        data: {
          access_token
        }
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/")
      }
    },
    
    async google_login_business(context, access_token) {
      let response = await api({
        url: `/google-login-business`,
        method: 'POST',
        data: {
          access_token
        }
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/")
      }
    },
    async facebook_login(context, access_token) {
      let response = await api({
        url: `/facebook-login`,
        method: 'POST',
        data: {
          access_token
        }
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/")
      }
    },
    async facebook_login_business(context, access_token) {
      let response = await api({
        url: `/facebook-login-business`,
        method: 'POST',
        data: {
          access_token
        }
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/")
      }
    },
    async validate(context, options) {
      let response = await api({
        url: `/validate`,
        method: "POST",
        data: {
          phone: options.phone,
          email: options.email
        }
      })
      context.commit('validation_success', response.token)
    },
    async register(context, data) {
      //data.sms_token = context.state.sms_token
      let response = await api({
        url: `/register`,
        method: "POST",
        data: data
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/user/profile")
      }
    },
    async register_business(context, data) {
      //data.sms_token = context.state.sms_token
      let response = await api({
        url: `/register-business`,
        method: "POST",
        data: data
      })
      if (!response.token) {
        throw "No token"
      }
      context.commit('set_token', response.token);
      await context.dispatch('loadAccount')
      if (context.state.continue) {
        router.push(context.state.continue)
      } else {
        router.push("/business/profile")
      }
    },
    async acceptTerms(context) {
      await api({
        url: `/account`,
        method: "POST",
        data: {
          accepted_terms: 1
        }
      })
      context.state.show_terms = false;
    },
    deleteResume: async function(context) {
      await api({
        method: "POST",
        url: `/account`,
        data: {
          resume: null
        }
      })
      context.state.account.resume = null;
    },
    uploadResume: async function(context, file) {
      let upload_url = await api({
        method: "POST",
        url: `/account/upload-url`,
        data: {
          file: {
            name: file.name,
            size: file.size,
            type: file.type
          },
          key: `resume`
        }
      })
      var upload_options = {
        headers: {
          'Content-Type': file.type,
          'x-amz-acl': 'public-read'
        },
        'Metadata': {
          'Content-Disposition': 'attachment'
        }
      };
      await Axios.put(upload_url, file, upload_options)
      await api({
        method: "POST",
        url: `/account`,
        data: {
          resume: upload_url.split("?")[0]
        }
      })
      context.state.account.resume = file;
    },
    async forgot_password(context, email) {
      await api({
        url: `/forgot-password`,
        method: "POST",
        data: {
          email: email
        }
      })
    },
    async reset_password(context, options) {
      await api({
        url: `/reset-password`,
        method: "POST",
        data: {
          password: options.password,
          token: options.token
        }
      })
    },
    async update(context, options) {
      await api({
        url: `/account`,
        method: "POST",
        data: options
      })
      context.dispatch('loadAccount')
    },
    async updateProfilePassword(context, options) {
      await api({
        url: `/account/user/profile-password`,
        method: "POST",
        data: options
      })
      context.state.account.profile_password = true
      context.dispatch('profile_view/clear_password', null, {
        root: true
      })
    },
    async clearProfilePassword(context, options) {
      await api({
        url: `/account/user/profile-password`,
        method: "DELETE",
        data: options
      })
      context.state.account.profile_password = false
    },
    async toggle_bookmark(context, id) {
      context.commit('toggle_bookmark', id)
      await api({
        url: `/account/bookmark-contest/${id}`,
        method: "GET"
      })
    }
  }
}


/*

async forgot_password(context, email) {

},
async register(context, details) {

},
async verify(context, details) {

}

*/
